function initializeVariantHandler() {
  if (!window.location.href.includes('/products/')) {
    return;
  }

  const productForm = document.querySelector('form.product-form');

  if (!productForm) {
    console.warn("Product form not found after section load!");
    return;
  }

  const addToCartButton = productForm.querySelector('button[type="submit"]');
  const variantInput = productForm.querySelector('input[name="id"]');
  const variantData = document.querySelector('[type="application/json"][data-product-variants]');

  if (!variantData) {
    console.error("Variant data not found after section load!");
    return;
  }

  const allVariants = JSON.parse(variantData.textContent);
  const selectors = document.querySelectorAll('[data-option-name] input');

  function updateSelectedVariant() {
    const selectedOptions = [];

    document.querySelectorAll('[data-option-name]').forEach(fieldset => {
      const selectedInput = fieldset.querySelector('input:checked');
      if (selectedInput) {
        selectedOptions.push(selectedInput.value.trim());
      }
    });

    const matchingVariant = allVariants.find(variant => {
      return variant.options.every((opt, idx) => opt === selectedOptions[idx]);
    });

    if (matchingVariant) {
      variantInput.value = matchingVariant.id;
      addToCartButton.disabled = false;
    } else {
      addToCartButton.disabled = true;
    }
  }

  selectors.forEach(selector => {
    selector.addEventListener('change', updateSelectedVariant);
    selector.addEventListener('click', updateSelectedVariant);
  });

  updateSelectedVariant(); // Run once on load
}

// Run when page loads
document.addEventListener('DOMContentLoaded', initializeVariantHandler);

// Run again if Shopify sections load dynamically
document.addEventListener('shopify:section:load', initializeVariantHandler);
